import {Component} from '@angular/core';
import {DataStoreService} from 'app/shared/data-store/services/data-store.service';

@Component({
  selector: 'app-how-to-unregister',
  templateUrl: './how-to-unregister.component.html',
  styleUrls: ['./how-to-unregister.component.css'],
})

export class HowToUnregisterComponent {

}


